/*
  WU — Venta flash: reloj e inventario compartidos por la barra superior
  (snippets/wu-flash-bar.liquid) y el widget del home (sections/wu-flash-sale.liquid).

  - La ventana sale de data-start (hora CDMX, UTC-6 fijo) + data-hours.
  - Fuera de la ventana, o con todas las piezas agotadas, cada [data-wu-flash] queda hidden.
  - Las piezas restantes las calcula Liquid con el inventario real de la variante,
    topadas al cupo. Este archivo no inventa existencias.
  - Solo fuera del tema publicado (theme dev / preview) se aceptan simulaciones:
      ?flash_sim=1:12,2:0,c2:3   piezas restantes por producto (1, 2) y cupones (c1, c2)
      ?flash_state=upcoming|ended
*/
(function () {
  if (window.WUFlash) { window.WUFlash.scan(); return; }

  var CDMX = '-06:00';
  var LOW = 0.2; // a partir de aquí el medidor cambia a "últimas piezas"
  var roots = [];
  var timer = null;

  function parseStart(s) {
    s = (s || '').trim();
    if (!s) return null;
    if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}$/.test(s)) s += ':00';
    var d = new Date(s.replace(' ', 'T') + CDMX);
    return isNaN(d.getTime()) ? null : d.getTime();
  }

  var sim = (function () {
    var out = { stock: {}, state: null };
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    if (role === 'main') return out;
    var q = new URLSearchParams(location.search);
    (q.get('flash_sim') || '').split(',').forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2 && kv[1] !== '' && !isNaN(+kv[1])) out.stock[kv[0].trim()] = Math.max(0, +kv[1]);
    });
    var st = q.get('flash_state');
    if (st === 'upcoming' || st === 'ended') out.state = st;
    return out;
  })();

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function setDigit(el, val) {
    if (!el || el.textContent === val) return;
    el.textContent = val;
    el.classList.remove('is-tick');
    void el.offsetWidth; // reinicia la animación
    el.classList.add('is-tick');
  }

  function paintStock(root) {
    var items = root.querySelectorAll('[data-wu-flash-item]');
    var alive = 0;
    items.forEach(function (it) {
      var key = it.getAttribute('data-key');
      var cap = +it.getAttribute('data-cap') || 1;
      var left = +it.getAttribute('data-remaining');
      if (key in sim.stock) left = Math.min(sim.stock[key], cap);
      left = Math.max(0, Math.min(left, cap));
      if (left > 0) alive++;

      it.classList.toggle('is-low', left > 0 && left / cap <= LOW);
      it.classList.toggle('is-out', left === 0);

      var segs = it.querySelectorAll('[data-seg]');
      var on = Math.ceil((left / cap) * segs.length);
      segs.forEach(function (s, i) { s.classList.toggle('on', i < on); });

      var txt = it.querySelector('[data-left-text]');
      if (txt) {
        if (left === 0) txt.innerHTML = '<b>Volaron</b> los ' + cap + ' frascos 💔';
        else if (left === 1) txt.innerHTML = '<b>¡Queda uno!</b> Es el último';
        else if (left / cap <= LOW) txt.innerHTML = '<b>¡Solo quedan ' + left + '!</b> de ' + cap + ' frascos';
        else txt.innerHTML = 'Quedan <b>' + left + '</b> de ' + cap + ' frascos';
      }
      var btn = it.querySelector('[data-atc]');
      if (btn) {
        btn.disabled = left === 0;
        var lbl = btn.querySelector('[data-atc-label]');
        if (lbl) lbl.textContent = left === 0 ? 'Ya se acabaron' : lbl.getAttribute('data-default');
      }
    });
    return alive;
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function setUse(cp, applied) {
    cp.classList.toggle('is-applied', applied);
    var use = cp.querySelector('[data-use]');
    if (use && !use.disabled) use.textContent = applied ? 'Aplicado ✓' : 'Usar cupón';
  }

  // Cupones: mismo cupo/medidor que los productos, pero no apagan la venta al agotarse.
  function paintCoupons(root) {
    var current = getCookie('discount_code').toUpperCase();
    root.querySelectorAll('[data-wu-flash-coupon]').forEach(function (cp) {
      var key = cp.getAttribute('data-key');
      var code = cp.getAttribute('data-code');
      var cap = +cp.getAttribute('data-cap') || 1;
      var left = +cp.getAttribute('data-remaining');
      if (key in sim.stock) left = Math.min(sim.stock[key], cap);
      left = Math.max(0, Math.min(left, cap));

      cp.classList.toggle('is-low', left > 0 && left / cap <= 0.25);
      cp.classList.toggle('is-out', left === 0);
      var segs = cp.querySelectorAll('[data-seg]');
      var on = Math.ceil((left / cap) * segs.length);
      segs.forEach(function (s, i) { s.classList.toggle('on', i < on); });

      var txt = cp.querySelector('[data-left-text]');
      if (txt) {
        if (left === 0) txt.innerHTML = '<b>Se acabaron</b> los ' + cap;
        else if (left === 1) txt.innerHTML = '<b>¡Queda uno!</b>';
        else if (left / cap <= 0.25) txt.innerHTML = '<b>¡Solo quedan ' + left + '!</b> de ' + cap;
        else txt.innerHTML = 'Quedan <b>' + left + '</b> de ' + cap;
      }

      var use = cp.querySelector('[data-use]');
      var copy = cp.querySelector('[data-copy]');
      if (use) {
        use.disabled = left === 0;
        if (left === 0) use.textContent = 'Ya no hay';
      }
      if (copy) copy.disabled = left === 0;
      if (left > 0) setUse(cp, current === code);

      if (cp.__wuBound) return;
      cp.__wuBound = true;
      if (copy) copy.addEventListener('click', function () {
        var label = copy.firstChild;
        var done = function () { label.nodeValue = '¡Copiado!'; setTimeout(function () { label.nodeValue = code; }, 1600); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
        else done();
      });
      // Igual que el carrito (wu-cart-drawer): /discount/ deja el código en la sesión
      // y Shopify lo aplica en el checkout si la compra llega al mínimo.
      if (use) use.addEventListener('click', function () {
        if (use.disabled) return;
        use.disabled = true;
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .catch(function () {})
          .then(function () {
            use.disabled = false;
            root.querySelectorAll('[data-wu-flash-coupon]').forEach(function (o) { setUse(o, o === cp); });
          });
      });
    });
  }

  function stateOf(r, now) {
    if (sim.state) return sim.state;
    if (now < r.start) return 'upcoming';
    if (now >= r.end) return 'ended';
    return 'live';
  }

  function tick() {
    var now = Date.now();
    var anyLive = false;
    roots.forEach(function (r) {
      var st = stateOf(r, now);
      var live = st === 'live' && !r.soldOut;
      r.el.hidden = !live;
      r.el.setAttribute('data-state', r.soldOut ? 'soldout' : st);
      if (!live) return;
      anyLive = true;

      var left = Math.max(0, r.end - now);
      var sec = Math.floor(left / 1000);
      var h = pad(Math.floor(sec / 3600));
      var m = pad(Math.floor((sec % 3600) / 60));
      var s = pad(sec % 60);
      r.el.querySelectorAll('[data-wu-flash-clock]').forEach(function (c) {
        setDigit(c.querySelector('[data-h]'), h);
        setDigit(c.querySelector('[data-m]'), m);
        setDigit(c.querySelector('[data-s]'), s);
      });
      var track = r.el.querySelector('[data-time-track]');
      if (track) track.style.setProperty('--elapsed', ((1 - left / (r.end - r.start)) * 100).toFixed(2) + '%');
    });
    document.documentElement.classList.toggle('wu-flash-live', anyLive);
  }

  function scan() {
    document.querySelectorAll('[data-wu-flash]').forEach(function (el) {
      if (el.__wuFlash) return;
      var start = parseStart(el.getAttribute('data-start'));
      var hours = +el.getAttribute('data-hours') || 48;
      if (start === null) return;
      el.__wuFlash = true;
      var end = start + hours * 3600000;
      roots.push({ el: el, start: start, end: end, soldOut: false });

      var lbl = el.querySelector('[data-end-label]');
      if (lbl) {
        lbl.textContent = new Date(end).toLocaleString('es-MX', {
          timeZone: 'America/Mexico_City', weekday: 'long', day: 'numeric', month: 'short',
          hour: 'numeric', minute: '2-digit', hour12: true
        }).replace(/\./g, '');
      }
    });

    // Barra y widget leen el mismo inventario: con todo agotado se apagan los dos.
    roots.forEach(function (r) { r.soldOut = paintStock(r.el) === 0; paintCoupons(r.el); });

    tick();
    if (!timer) timer = setInterval(tick, 1000);
  }

  // Lo que está en flash mientras la venta está en vivo. Lo leen el cart drawer y Daniela:
  // el flash no se combina con la escalera, así que no deben prometer sus escalones.
  function liveList(attr) {
    if (!document.documentElement.classList.contains('wu-flash-live')) return [];
    var out = [];
    roots.forEach(function (r) {
      (r.el.getAttribute(attr) || '').split(',').forEach(function (h) {
        h = h.trim();
        if (h && out.indexOf(h) === -1) out.push(h);
      });
    });
    return out;
  }
  function liveHandles() { return liveList('data-handles'); }
  function inCart(cart) {
    var ids = liveList('data-variants');
    return !!(cart && cart.items && cart.items.some(function (i) { return ids.indexOf(String(i.variant_id)) > -1; }));
  }

  // ¿El código guardado en la sesión es uno de los cupones de la venta flash?
  function codeActive() {
    var c = getCookie('discount_code').toUpperCase();
    return !!c && liveList('data-codes').indexOf(c) > -1;
  }

  window.WUFlash = { scan: scan, liveHandles: liveHandles, inCart: inCart, codeActive: codeActive };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
